import { getGlobalConfig } from '../utils';
export default class ValidationResult {
    constructor(props) {
        Object.assign(this, props);
    }
    get validationMessage() {
        const { $validationMessage, injectionOptions } = this;
        if ($validationMessage && injectionOptions) {
            const { name, dataSet } = this.validationProps;
            return getGlobalConfig('validationMessageFormatter', dataSet && dataSet.getField(name))($validationMessage, injectionOptions);
        }
        return $validationMessage;
    }
    set validationMessage(validationMessage) {
        this.$validationMessage = validationMessage;
    }
}
